export const objectToSearchParams = <T extends {}>(obj: T, ignoredKeys: string[] = [], explicitKeys: string[] = []): URLSearchParams => {
    const searchParams = new URLSearchParams()

    Object.entries(obj).forEach(([key, value]) => {
        if (!explicitKeys?.includes(key) && (!value || ignoredKeys?.includes(key)))
            return
        if (value instanceof Date) {
            searchParams.set(key, value.toISOString())
        }
        else if (typeof value === 'number') {
            searchParams.set(key, value.toString())
        }
        else if (typeof value === 'boolean') {
            searchParams.set(key, value.toString())
        }
        else if (typeof value === 'string') {
            searchParams.set(key, value)
        }
    })

    return searchParams
}

export const searchParamsToObject = (searchParams: URLSearchParams, ignoredKeys: string[] = [], explicitKeys: string[] = []) => {
    const obj: any = {}

    searchParams.forEach((value, key) => {
        if (!explicitKeys?.includes(key) && (!value || ignoredKeys?.includes(key)))
            return
        if (!isNaN(Number(value)))
            obj[key] = Number(value)
        else if (!isNaN(Date.parse(value)))
            obj[key] = new Date(value)
        else if (value === 'true' || value === 'false')
            obj[key] = value === 'true'
        else
            obj[key] = value
    })

    return obj
}